/* eslint-disable no-console */
import React, { useCallback, useEffect, useId, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ProfilePic = (props) =>
{
	const { imagePath, defaultImg, alt, loadUrl, className,
		effect = undefined, from, delayTime, style, onError, onLoad } = props;
	const { isFullPath = (loadUrl === 'profile') } = props;

	const profileImagePath = from === 'selfProfile' ? imagePath !== '' && imagePath?.replace && imagePath?.replace('.jpeg', '_profile.jpeg') : '';
	const tempId = useId();

	// Function to replace timestamp parameter with temporary id
	const replaceTimestampWithTempId = (url) =>
	{
		// Guard against non-string values (e.g., false, null, undefined)
		if (!url || typeof url !== 'string') return url;

		const timestamp = new Date().valueOf();

		// Check if the URL already contains ?t= parameter
		const timestampPattern = /(\?t=)\d+/;

		if (timestampPattern.test(url))
		{
			// Replace existing timestamp
			return url.replace(timestampPattern, `$1${timestamp}`);
		}

		// Add timestamp parameter to end of URL
		const separator = typeof url === 'string' && url.includes('?') ? '&' : '?';

		return `${url}${separator}t=${timestamp}`;
	};

	const getImageUrl = () =>
	{
		const image = isFullPath
			? imagePath
			: from === 'selfProfile'
				? `${process.env.REACT_APP_S3_BASE_URL}/profile/${profileImagePath}` // for user profile
				: `${process.env.REACT_APP_S3_BASE_URL}/profile/${imagePath}`; // for company profile

		return replaceTimestampWithTempId(image);
	};
	const [ imageUrl, setImageUrl ] = useState(getImageUrl);
	const [ objectFitStyle, setObjectFitStyle ] = useState('cover');

	const handleImageError = useCallback(() =>
	{
		onError && onError();
		setImageUrl(defaultImg || '/images/icons/defaultUser.svg');
	}, [ imageUrl, defaultImg, onError ]);

	const handleImageLoad = (event) =>
	{
		onLoad && onLoad();
		const imgWidth = event.target.naturalWidth;
		const imgHeight = event.target.naturalHeight;

		// console.log('Image dimensions:', imgWidth, imgHeight);

		if (imgWidth > imgHeight)
		{
			setObjectFitStyle('contain');
		}
		else if (imgWidth === imgHeight)
		{
			setObjectFitStyle('cover');
		}
		else
		{
			setObjectFitStyle('cover');
		}
	};

	useEffect(() =>
	{
		setImageUrl(getImageUrl());
	}, [ imagePath ]);

	return (
		<>
			<LazyLoadImage
				key={imageUrl}
				src={imageUrl}
				alt={alt || 'img'}
				style={style || { objectFit: objectFitStyle, height: 'inherit' }}
				className={className || 'brdrRadius50'}
				onError={handleImageError}
				delayTime={delayTime ?? process.env.REACT_APP_PROFILE_DELAY_TIME}
				effect={effect ?? process.env.REACT_APP_EFFECT}
				onLoad={handleImageLoad}
			/>
		</>
	);
};

export default React.memo(ProfilePic);